import Axios from "axios";
import { parcelTerminalBulder } from "../../helpers/Utils";
import { flattenObject } from "../../helpers/object";


export const getParcelTerminals = async () => {
  try {
    const { data } = await Axios.get("/api/v1/parcel_terminal");
    return { success: true, data: parcelTerminalBulder(data) };
  } catch (e) {
    console.log("Error: ", e);
    return { suceess: false };
  }
};


export const getParcelTerminal = (parcel_terminal_id) => (_, getState) => {
  if (!parcel_terminal_id) return null;
  const { parcel_terminals } = getState().options;
  return flattenObject(parcel_terminals).find((parcel_terminal) => parcel_terminal.value == parcel_terminal_id);
}

